.spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--hs-spacing-3);
  padding: var(--hs-spacing-10) 0;
  color: var(--hs-color-text-secondary);
  font: var(--hs-type-body);
}
.ring {
  width: 20px;
  height: 20px;
  border: 2px solid var(--hs-color-border-default);
  border-top-color: var(--hs-color-primary-default);
  border-radius: var(--hs-radius-full);
  animation: hs-spin 0.8s linear infinite;
}
@keyframes hs-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .ring {
    animation-duration: 2.4s;
  }
}
